import { api } from "../AxiosInstance";
import { urlQueryBuilder } from "../utils/urlQueryBuilder";

export interface Location {
  id: number;
  name: string;
  address: string;
  latitude: number;
  longitude: number;
  label?: string;
  description?: string;
  contactPerson?: string;
  contactPhone?: string;
  contactEmail?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

const LocationService = {
  // Get all locations (paginated, filter, search)
  getAllLocations: async (
    queryParams: {
      limit?: number;
      skip?: number;
      label?: string;
      search?: string;
      latitude?: number;
      longitude?: number;
      radius?: number;
    } = {}
  ) => {
    try {
      const queryString = urlQueryBuilder(queryParams);
      const response = await api.get(
        `/location${queryString ? `?${queryString}` : ""}`
      );
      return response;
    } catch (error) {
      console.error("Error getAllLocations:", error);
      throw error;
    }
  },

  // Create a new location
  createLocation: async (location: Partial<Location>) => {
    try {
      const response = await api.post("/location", location);
      return response;
    } catch (error) {
      console.error("Error createLocation:", error);
      throw error;
    }
  },

  // Update location by ID
  updateLocation: async (id: number, location: Partial<Location>) => {
    try {
      const response = await api.put(`/location/${id}`, location);
      return response;
    } catch (error) {
      console.error("Error updateLocation:", error);
      throw error;
    }
  },

  // Delete location by ID (soft delete)
  deleteLocation: async (id: number) => {
    try {
      const response = await api.delete(`/location/${id}`);
      return response;
    } catch (error) {
      console.error("Error deleteLocation:", error);
      throw error;
    }
  },

  // Get location by ID
  getLocationById: async (id: number) => {
    try {
      const response = await api.get(`/location/${id}`);
      return response;
    } catch (error) {
      console.error("Error getLocationById:", error);
      throw error;
    }
  },

  // Search locations (advanced)
  searchLocations: async (
    queryParams: {
      q?: string;
      label?: string;
      latitude?: number;
      longitude?: number;
      radius?: number;
      limit?: number;
    } = {}
  ) => {
    try {
      const queryString = urlQueryBuilder(queryParams);
      const response = await api.get(
        `/location/search${queryString ? `?${queryString}` : ""}`
      );
      return response;
    } catch (error) {
      console.error("Error searchLocations:", error);
      throw error;
    }
  },

  // Get locations by label
  getLocationsByLabel: async (label: string) => {
    try {
      const response = await api.get(`/location/label/${label}`);
      return response;
    } catch (error) {
      console.error("Error getLocationsByLabel:", error);
      throw error;
    }
  },

};

export default LocationService;
